import {
  SET
} from 'reducer/types/prefix'

export const CATEGORY = 'CATEGORY'

export const SET_CATEGORY = `${SET}${CATEGORY}`